import { z } from 'zod';

/**
 * What a tariff may look like while it is still being typed: optional sign, digits, at most two
 * decimals. Kept beside the schema because the two describe the same figure at different moments
 * — this one rejects a keystroke, the schema rejects a value.
 */
export const FUEL_LEVY_TARIFF_PATTERN = /^-?\d*(\.\d{0,2})?$/;

/** The API accepts a tariff from -100 to 100, and both fuel levy dialogs write one. */
export const fuelLevyTariffSchema = z.number({
	required_error: 'Fuel levy is required',
	invalid_type_error: 'Fuel levy is required'
})
	.min(-100, 'Fuel levy can\'t be less than -100')
	.max(100, 'Fuel levy must not be greater than 100');
